import { Step } from '@acorns/web-components'
import * as H from 'history'

import type { Props as EnhancedFlowProviderProps } from './index'
import { VALID_FLOWS } from './utils'

export type Flow = (typeof VALID_FLOWS)[number]

export type FlowProviderProps = {
  history: H.History
  location: H.Location
  visitedPages?: string[]
}

export type FlowProviderActionProps = Partial<FlowEntryActionFnProps> & EnhancedFlowProviderProps

export type FlowProviderState = {
  userState: any
}

export type FlowProviderRedirectConfig = {
  from?: FlowRoute
  action: string
  path?: FlowRoute
  state?: any
  locationState?: any
  forwardQueryParams?: boolean
  doNotTrackVisited?: boolean
  queryParams?: object
}

export type FlowEntryAction = {
  name: string
  stepEvent?: string
  goTo: (state: any, props: FlowProviderActionProps) => FlowRoute
}

export interface FlowEntryActionFnProps {
  visitedPages: string[]
  setFlow: (flow: Flow) => void
  actionName: string
  isRegistrationFlow: boolean
  isAnalytics?: boolean
}

export type FlowProgress = {
  stepIndex?: number
  stepPartialProgress?: number
  stepOverallProgress?: number
}

export type FlowProgressWithSteps = FlowProgress & {
  steps: Step[]
}

export type FlowEntry = {
  page: FlowRoute
  progress?: FlowProgress
  actions: FlowEntryAction[]
  isFirstPage?: true
}

export enum FlowRoute {
  AddressEdit = '/address-edit',
  AddressInvalid = '/address-invalid',
  AddressPreview = '/address-preview',
  AddressSuggestion = '/address-suggestion',
  AnnualIncome = '/annual-income',
  BankLinkSuccess = '/bank-link-success',
  ChooseFundingSource = '/choose-funding-source',
  CombinedAnnualIncome = '/combined-annual-income',
  ContactInfo = '/contact-info',
  DateOfBirth = '/date-of-birth',
  Employees = '/employees',
  EmploymentStatus = '/employment-status',
  FinancialEducation = '/financial-education',
  Funding = '/funding',
  Institutions = '/institutions',
  DirectBankIntegration = '/institution/link',
  DirectBankIntegrationRedirect = '/institution/redirect',
  HDYHAU = '/hdyhau',
  InvestInterstitial = '/invest-interstitial',
  InvestmentGoal = '/investment-goal',
  InvestorQuestions = '/investor-questions',
  KidsInvesting = '/kids-investing',
  LaterInterstitial = '/later-interstitial',
  LaterIraRecommendation = '/later-ira-recommendation',
  LaterSuitabilityQuestions = '/later-suitability-questions',
  ManualFundingSource = '/manual-funding-source',
  MaritalStatus = '/marital-status',
  MFASetup = '/mfa-setup',
  NetWorth = '/net-worth',
  OneTimeInvestment = '/one-time-investment',
  PersonalInfo = '/personal-info',
  PhoneNumber = '/phone-number',
  Portfolio = '/portfolio',
  ProductOnboarding = '/product-onboarding',
  PreviewPortfolio = '/preview-portfolio',
  AboutPortfolio = '/about-portfolio',
  PricingInterstitial = '/pricing-interstitial',
  RecurringInvestment = '/recurring-investment',
  RoundUpsInterstitial = '/round-ups-interstitial',
  RoundUpsSetup = '/round-ups-setup',
  RoundUpsFunding = '/round-ups-funding',
  RoundUpsPast = '/round-ups-past',
  SelfEmployedIncome = '/self-employed-income',
  Signup = '/signup',
  SSN = '/ssn',
  SubscriptionActive = '/subscription-active',
  Success = '/success',
  SuitabilityQuestionsRoot = '/suitability-questions',
  SuitabilityQuestions = '/suitability-questions/:index',
  TaxFilingType = '/tax-filing-type',
  Welcome = '/',
  PlaidLinkRedirect = '/plaid-link-redirect',
}
